import { GetInteractor } from '@coris-ts/repository/interactor/get.interactor'
import { type UsersChatPage, type UsersChatSortBy } from '../models/engagement-users'
import { GetUsersChatQuery } from '../../data/queries/get-users-chat.query'
import { type UsersChatPageEntity } from '../../data/entities/users.entity'

export interface GetUsersChatParams {
  fromDate: string
  toDate: string
  fromPrevious: string
  toPrevious: string
  sortBy: UsersChatSortBy
  sortOrder: 'asc' | 'desc'
  offset: number
  limit: number
  organization: string
}

export class GetUsersChatInteractor {
  constructor(private readonly repository: GetInteractor<UsersChatPageEntity>) {}

  public async execute(params: GetUsersChatParams): Promise<UsersChatPage> {
    return await this.repository.execute(
      new GetUsersChatQuery(
        params.fromDate,
        params.toDate,
        params.fromPrevious,
        params.toPrevious,
        params.sortBy,
        params.sortOrder,
        params.offset,
        params.limit,
        params.organization
      )
    )
  }
}
